import 'core-js/stable';
import './luxonSettings';

import { installDomTranslationGuard } from './domTranslationGuard';

// webpack.config.js prepends this file to every pack entry, so this guards all React pages.
installDomTranslationGuard();

(function () {
  if (typeof window !== 'undefined' && window.crypto && !window.crypto.randomUUID) {
    window.crypto.randomUUID = function (): `${string}-${string}-${string}-${string}-${string}` {
      const b = window.crypto.getRandomValues(new Uint8Array(16));
      b[6] = (b[6] & 0x0f) | 0x40;
      b[8] = (b[8] & 0x3f) | 0x80;
      const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
      return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}` as `${string}-${string}-${string}-${string}-${string}`;
    };
  }
})();

export {};
